<template>
    <span>
        <v-dialog max-width="600px">
        <span column slot="activator" class="fab-container">
            <v-btn icon class="mx-0" @click="edit(name)">
                      <v-icon color="black">credit_card</v-icon>
           </v-btn>
           
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>SELL REFRESHMENT</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
                
                
             </v-card-text>
             <v-card-text>
                 <v-form class="px-3" ref="editform"> 
                     <v-text-field label="Movie Category*" v-model="category" readonly prepend-icon="money"></v-text-field>
                     <v-text-field label="Movie Name*" v-model="movName" readonly prepend-icon="comment"></v-text-field>
                     <v-text-field label="Movie Price*" v-model="price" readonly prepend-icon="money"></v-text-field>
                     <v-text-field label="Slots Remaining*" v-model="slots" readonly prepend-icon="comment"></v-text-field>
                     <v-text-field label="Viewing Date*" v-model="vDate" readonly prepend-icon="money"></v-text-field>
                     <v-text-field label="Viewing Time*" v-model="vTime" readonly prepend-icon="money"></v-text-field>
                     
                     <v-select label="Quantity*" item-text="qty" :items="[{header:'Quantity'},1,2,3,4,5,6,7,8,9,10]" v-model="quantity"  prepend-icon="more"></v-select>
                     <span v-if="error_state" class="red--text">{{error_value}}</span>
                    <span> * indicates required field </span>
                </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isLoading">SELL </v-btn>
             </v-card-actions>
         </v-card>
        </v-dialog>
   </span>
</template>

<script>
import {sellModule} from '@/model';
import moment from 'moment';


export default {
    name: 'EditRefreshment',
    props:{
        name:{
             required:true
        },
        movName:{
            required:true
        },
        category:{
            required:true
        },
        price:{
            required:true
        },
        slots:{
            required:true
        },
        vDate:{
            required:true
        },
        vTime:{
            required:true
        },
        campus:{
            required:true
        }

    },
    data() {
        return {
            staff:this.$store.getters.getStaff,
            error_state:false,
            error_value:"You must select a quantity",
            isDisabled:false,
            isLoading:false,
            quantity:'',
            
        };
    },
    watch:{
        slots: function(val){
            if(val<1){
                this.isDisabled = true;
                this.isLoading = false
            }
        }
    },
    methods: {
        edit(name){
            console.log("Edit ",name);
            
        },
        
        add() {
            let self=this;
            if(this.$refs.editform.validate()){
            if(this.quantity==0){
                    self.error_state = true;
                    
                    return
            }
            
            let amount = (this.price * this.quantity );
            let o = self.quantity > 1 ? ' tickets of ' : ' ticket of ';
            let confirmed =  confirm('You are about to sell '+self.quantity+o+
            this.movName+' under '+this.category+' category which amounts to N'+amount+'.\nContinue?',
            'Exodus');
            self.error_state = false;
            if(confirmed){
            
           
            let datenow = moment().format('DD/MM/YYYY');
            
            let itemname = (this.movName+this.category+this.vDate+this.vTime).toLowerCase();
            
            let useradd = this.$store.getters.getStaff.name;
            let newitem = {type:'staff',mov_name:this.movName,category:this.category,price:Number(this.price),vDate:this.vDate,vTime:this.vTime,dateadded:datenow,usersold:useradd};
            console.log(newitem);
            self.isDisabled = true;
            self.isLoading = true;
             sellModule('campus',this.campus,'ticket',itemname,newitem,this.quantity,function(response){
                if(response.value == true){
                    console.log("This is response: ",response);
                     alert('Sold '+response.data.length+' ticket out of '+ self.quantity+' sent');
                     self.isDisabled = false;
                     self.isLoading = false;
                    
                  }else{
                      if(response.err == 'under'){
                          alert("The quantity you are planning on selling is more than the current available slot");
                      }
                      console.log(null);
                      self.isDisabled = false;
                      self.isLoading = false;
                    
                  }

              });
                    }
                          }
        }
    }
};
</script>

<style scoped>
</style>